module.exports = ASVideoPlayer;


/*****************
 ** WEBPACK FOOTER
 ** external "ASVideoPlayer"
 ** module id = 761
 ** module chunks = 1
 **/